import { render } from "./AccessTenant.vue?vue&type=template&id=5946b410&scoped=true"
import script from "./AccessTenant.vue?vue&type=script&lang=js"
export * from "./AccessTenant.vue?vue&type=script&lang=js"

import "./AccessTenant.vue?vue&type=style&index=0&id=5946b410&scoped=true&lang=css"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5946b410"]])

export default __exports__